/**
 *
 * @module component/helpers
 * @author shojib [mahmud.hossain@mlb.com]
 * @description module for adding handlebars helpers
 *
 */

/**
 *
 * @name HBHelpers
 * @description handlebars helpers to be registered.
 *
 */
const HBHelpers = {

    /**
     *
     * @function ifOr
     * @param {Boolean} a
     * @param {Boolean} b
     * @param {Object} options
     * @returns {Function}
     *
     */
    ifOr(a, b, options) {

        if (a || b) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }

    },

    /**
     *
     * @function ifAnd
     * @param {Boolean} a
     * @param {Boolean} b
     * @param {Object} options
     * @returns {Function}
     *
     */
    ifAnd(a, b, options) {

        if (a && b) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }

    },

    /**
     *
     * @function withItem
     * @description access object value with a variable key
     * @param {Object} obj
     * @param {Object} options
     * @returns {Function}
     *
     */
    withItem(obj, options) {

        return options.fn(obj[options.hash.key]);

    }

};

export default HBHelpers;
